export function obtenerTipoDispositivo() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/mobile|android/.test(userAgent)) {
    return 'Móvil';
  } else if (/tablet|ipad/.test(userAgent)) {
    return 'Tablet';
  } else {
    return 'computador';
  }
}